import {FC} from 'react'

interface Props {
    title: string
    action:Function
    id:string
    className:string
    active?:boolean
    loading?:boolean
}

const Button: FC<Props> = ({ loading, title, action, active, className, id}) => {
    const handleClick = () => {
        if(title==="Nästa steg" || title==="Slutför") {
            action()
        }else{
            if(active)
                action()
        }
    }

    className += active ? "" : " disabled"
    className += loading ? " disabled loading" : ""

    return (
        <div id={id} className={className}  onClick={() => handleClick()}>
            <div className="btn-text">{title}</div>
            {loading && (
                <i className="fas fa-spinner fa-spin" aria-hidden="true" />
            )}

        </div>
    )
};

export default Button
